import React, { Fragment, useCallback } from 'react';
import { Heading, Text, Box, Flex, Image } from 'roo-ui/components';
import { creditCardCID, creditCardCVV } from 'roo-ui/assets';
import Modal from 'components/Modal';
import TextButton from 'components/TextButton';
import { useModal } from 'lib/hooks';
import { useDataLayer } from 'hooks/useDataLayer';

const SecurityCodeModal = () => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();

  const handleOnClick = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'CCV Help Pop Up', value: "What's This Link Selected" });
  }, [openModal, emitInteractionEvent]);

  const handleClose = useCallback(() => {
    modalProps.onRequestClose();
    emitInteractionEvent({ type: 'CCV Help Pop Up', value: "What's This Link Collapsed" });
  }, [modalProps, emitInteractionEvent]);

  return (
    <Fragment>
      <TextButton onClick={handleOnClick} color="greys.steel" data-testid="security-code-cta">
        What&apos;s this?
      </TextButton>
      <Modal {...modalProps} onRequestClose={handleClose} padding={[4, 9]} title="Card Security Code">
        <Box mb="4" pb="4" mx={[0, 11]} borderBottom={1} borderColor="greys.alto">
          <Heading.h4 fontSize="base" mb={[3, 5]}>
            MasterCard or Visa
          </Heading.h4>
          <Flex flexDirection={['column', 'row']}>
            <Box data-testid="security-code-mastercard-visa-info">
              <Text>On MasterCard or Visa cards, the card security code (CVC/CVV2) is a group of </Text>
              <Text fontWeight="bold">three digits found on the back of your card.</Text>
            </Box>
            <Image
              ml={[0, 8]}
              mt={[4, 0]}
              flex="1 0 auto"
              width="110px"
              height="70px"
              src={creditCardCVV}
              alt="Mastercard and Visa CVC location"
              data-testid="security-code-mastercard-visa-figure"
            />
          </Flex>
        </Box>
        <Box mb="4" pb={[3, 1]} mx={[0, 11]}>
          <Heading.h4 fontSize="base" mb={[3, 5]}>
            American Express
          </Heading.h4>
          <Flex flexDirection={['column', 'row']}>
            <Box data-testid="security-code-amex-info">
              <Text>On American Express cards, the card security code (CID) is a group of </Text>
              <Text fontWeight="bold">four digits printed on the front.</Text>
            </Box>
            <Image
              ml={[0, 8]}
              mt={[4, 0]}
              flex="1 0 auto"
              width="110px"
              height="70px"
              src={creditCardCID}
              alt="American Express CID location"
              data-testid="security-code-amex-figure"
            />
          </Flex>
        </Box>
      </Modal>
    </Fragment>
  );
};

export default SecurityCodeModal;
